export const parseJson = (str?: string | null) => {
  try {
    if (!str) {
      return str
    }
    return JSON.parse(str)
  } catch (error) {
    return str
  }
}